"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _jsxFileName = "D:\\DXC\\Digital.UI.CommonStyling\\src\\lib\\components\\page-link\\index.jsx";

/**
 * Component for handling anchor tags for routing.
 * 
 * Specifically used to differentiate between complete urls which lead off the site
 * versus other urls used to route within the site using react-router.
 */
const PageLink = props => {
  if (!props.to) return null;

  const DirectLink = /*#__PURE__*/_react.default.createElement("a", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "aria-label": props === null || props === void 0 ? void 0 : props.label,
    target: props === null || props === void 0 ? void 0 : props.target,
    rel: props === null || props === void 0 ? void 0 : props.rel,
    href: props === null || props === void 0 ? void 0 : props.to,
    onClick: props === null || props === void 0 ? void 0 : props.onClick,
    onAuxClick: props === null || props === void 0 ? void 0 : props.onClick,
    onMouseEnter: props === null || props === void 0 ? void 0 : props.onMouseEnter,
    onMouseLeave: props === null || props === void 0 ? void 0 : props.onMouseLeave,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 24
    }
  }, props === null || props === void 0 ? void 0 : props.children);

  const RelativeLink = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: props === null || props === void 0 ? void 0 : props.className,
    "aria-label": props === null || props === void 0 ? void 0 : props.label,
    target: props === null || props === void 0 ? void 0 : props.target,
    rel: props === null || props === void 0 ? void 0 : props.rel,
    to: props === null || props === void 0 ? void 0 : props.to,
    onClick: props === null || props === void 0 ? void 0 : props.onClick,
    onAuxClick: props === null || props === void 0 ? void 0 : props.onClick,
    onMouseEnter: props === null || props === void 0 ? void 0 : props.onMouseEnter,
    onMouseLeave: props === null || props === void 0 ? void 0 : props.onMouseLeave,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 26
    }
  }, props === null || props === void 0 ? void 0 : props.children);

  const isDirectLink = props.to.indexOf('http') >= 0;
  const platformHandlesRelativeLink = window.USE_LINK;
  return !isDirectLink && platformHandlesRelativeLink ? RelativeLink : DirectLink;
}; // Set default props


exports.PageLink = PageLink;
PageLink.defaultProps = {
  onClick: null
};